import TagManager from 'react-gtm-module';
import { version } from '../../package.json';

function dataLayer(inputs) {
	const tagManagerArgs = {
		dataLayer: { ...inputs, event: 'event', version },
	};

	TagManager.dataLayer(tagManagerArgs);
}

export default dataLayer;
